<template>
    <zm-button data-testid="checkout-button-480" :data-url='targetUrl' size='lg' class='opc-succezz__view__account' :type='type' @click='goToBillingPage'>{{ $t('billing.zuoraoutage.view_my_plan_status') }}
    </zm-button>
  </template>
<script>
import { getEmailCTAsTrackingUrl, UTM_CONTENT_CODE } from '@/views/succezz/utils/email-ctas-tracking';
import { navigateToTargetPage } from '@/utils/modal-utils';

export default {
  props: {
    type: {
      type: String,
      default: 'primary',
    },
  },
  data() {
    return {
      targetUrl: getEmailCTAsTrackingUrl('/billing', {utmContent: UTM_CONTENT_CODE.viewMyPlanStatus})
    }
  },
  methods: {
    goToBillingPage() {
      this.$tracking.buyInteraction('purchase confirmation', 'view my plan status');
      // Use unified navigation util - automatically handles modal context
      navigateToTargetPage('/billing');
    },
  },
};
</script>

  <style lang='scss' scoped>
  @import '@zoom/billing-responsive/styles/responsive.scss';
  @import '@/styles/_variables.scss';

  .opc-succezz__view__account {
    &.zbo-button--plain:not(.is-ghost) {
      border: 1px solid #0C5CFF;

      .zbo-button__slot {
        color: #0C5CFF;
      }
    }
  }

  .opc-modal :deep {
    .opc-succezz__view__account {
      &.zbo-button.zbo-button--lg.zbo-button--plain.is-round {
        display: block;
        width: auto;
        padding: 8px 24px;
        border-radius: 12px;
        margin: 12px auto 0px;
        line-height: 22px;
      }
    }
  }
  </style>
